import { render, staticRenderFns } from "./Abonnement.vue?vue&type=template&id=2bcb2002&"
import script from "./Abonnement.vue?vue&type=script&lang=js&"
export * from "./Abonnement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports